// Matches dsc_backend_api ALLOWED_FILE_TYPES (server-side multer validation)
export const COMMUNICATION_ALLOWED_EXTENSIONS = [
  ".pdf",
  ".doc",
  ".ppt",
  ".jpg",
  ".jpeg",
  ".gif",
  ".excel",
  ".png",
  ".xlsx",
  ".xls",
  ".docx",
  ".txt",
  ".pptx",
];

export const COMMUNICATION_ALLOWED_MIME_TYPES = [
  "image/jpeg",
  "image/jpg",
  "image/png",
  "image/gif",
  "application/pdf",
  "application/msword",
  "text/plain",
  "application/vnd.ms-excel",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  "application/vnd.ms-powerpoint",
  "application/vnd.openxmlformats-officedocument.presentationml.presentation",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
];

const BLOCKED_MIME_TYPES = [
  "application/x-msdownload",
  "application/x-executable",
  "application/x-msdos-program",
  "application/vnd.microsoft.portable-executable",
];

export const COMMUNICATION_ATTACHMENT_ACCEPT =
  ".pdf,.doc,.docx,.ppt,.pptx,.jpg,.jpeg,.png,.gif,.xls,.xlsx,.txt,.excel";

export const COMMUNICATION_ATTACHMENT_ERROR_MSG =
  "Please upload valid Document (pdf, doc, ppt, jpg, jpeg, gif, excel, png, xlsx, xls, docx, txt, pptx).";

export const getFileExtension = (filename: string): string => {
  const dotIndex = filename.lastIndexOf(".");
  if (dotIndex < 0) {
    return "";
  }
  return filename.slice(dotIndex).toLowerCase();
};

export const isValidCommunicationAttachment = (file: File): boolean => {
  const extension = getFileExtension(file.name);
  if (!COMMUNICATION_ALLOWED_EXTENSIONS.includes(extension)) {
    return false;
  }

  if (file.type && BLOCKED_MIME_TYPES.includes(file.type)) {
    return false;
  }

  if (
    !file.type ||
    file.type === "application/octet-stream" ||
    file.type === "binary/octet-stream"
  ) {
    return true;
  }

  return COMMUNICATION_ALLOWED_MIME_TYPES.includes(file.type);
};

export const validateCommunicationAttachments = (
  files: File[]
): { valid: boolean; message: string } => {
  if (!files?.length) {
    return { valid: true, message: "" };
  }

  const invalidFile = files.find((file) => !isValidCommunicationAttachment(file));
  if (invalidFile) {
    return { valid: false, message: COMMUNICATION_ATTACHMENT_ERROR_MSG };
  }

  return { valid: true, message: "" };
};
